export default "__VITE_ASSET__BTMhugwf__"